import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

@Injectable()
export class LoginGuard implements CanActivate {
  constructor(private readonly router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    try {
      if (this.isClientAuthenticated()) {
        this.restoreSessionFromLocalStorage();
        this.router.navigateByUrl('/Dashboard');
        return false;
      }
      return true;
    } catch (error) {
      console.error('LoginGuard error:', error);
      return true;
    }
  }

  private isClientAuthenticated(): boolean {
    const sessionUserId = sessionStorage.getItem('UserId');
    if (sessionUserId && sessionUserId.trim() !== '' && sessionUserId !== '0') {
      return true;
    }

    const localUserId = localStorage.getItem('UserId');
    return !!(localUserId && localUserId.trim() !== '' && localUserId !== '0');
  }

  private restoreSessionFromLocalStorage(): void {
    const keys = [
      'UserId', 'UserName', 'LastLogin', 'clientTypeId', 'isUserByPass',
      'FirstLastName', 'userHasTracIt', 'ClientAccessibleTools', 'CompanyId',
      'DbaCompanyName', 'IsICalSubscription', 'EncyUserId', 'CompanyName',
      'isLogin', 'UserManu', 'UsercustomManu', 'useremail'
    ];

    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const sessionVal = sessionStorage.getItem(key);
      if (!sessionVal || sessionVal === '') {
        const localVal = localStorage.getItem(key);
        if (localVal != null && localVal !== '') {
          sessionStorage.setItem(key, localVal);
        }
      }
    }
  }
}
